import { baseTheme } from "./base";
const overrideColors = {
    P626: "#245C4E",
    P625: "#4E7F71",
    P624: "#779E91",
};
const colors = Object.assign(Object.assign(Object.assign({}, baseTheme.colors), overrideColors), { cl17: overrideColors.P626, cl18: overrideColors.P625, cl19: overrideColors.P624 });
colors.primaryLight = colors.cl17;
colors.primary = colors.cl18;
colors.primaryDark = colors.cl19;
export const twyfordTheme = Object.assign(Object.assign({}, baseTheme), { colors: Object.assign({}, colors) });
